import React, { useState } from "react";
import { PageLayoutWrapper, NavigationBarWrapper, PageContentWrapper, SidebarToggler } from "./Components/Common";
import NavigationBar from "./Components/NavigationBar";
import { useLocation } from "react-router-dom";
import { checkIfShouldHideSidebar, shouldPreventAPICall } from "./Utils";
import AppBanner from "@/Containers/Layout/AppBanner";
import { useSelector } from "react-redux";
import { RootState } from "@/Redux/Reducers";
import { LinearProgress } from "@mui/material";
import { useAuthAndSubscription } from "./Hooks/useAuthAndSubscription";

function PageLayout(props) {
  const { width = "100vw", height = "100vh", children } = props;
  const location = useLocation();

  const [expanded, setExpanded] = useState(true);

  const { pageLoaderVisibility } = useSelector((state: RootState) => ({
    pageLoaderVisibility: state.commonReducer.pageLoaderVisibility,
  }));

  const pathname = location?.pathname;
  const shouldHideSidebar = checkIfShouldHideSidebar(pathname);

  /**
   * no need to call API if it is DLP or login.
   */
  const preventAPICall = shouldPreventAPICall(pathname);

  /**
   * This hook is responsible for authenticating user
   * And fetching subscription details
   */
  useAuthAndSubscription({ preventAPICall });

  return !shouldHideSidebar ? 
    <PageLayoutWrapper width={width} height={height}>
      <AppBanner />
      <div className="tw-flex tw-flex-1 tw-overflow-auto">
        <NavigationBarWrapper expanded={expanded}>
          <NavigationBar expanded={expanded} setExpanded={setExpanded} />
        </NavigationBarWrapper>
        <PageContentWrapper>
          {pageLoaderVisibility && 
            <LinearProgress color="primary" className="w-100 !tw-absolute tw-inset-0 tw-p-[2px]" />
          }
          {children}
        </PageContentWrapper>
      </div>
    </PageLayoutWrapper>
   : 
    children
  ;
}

export default React.memo(PageLayout);
